import { useState, useEffect } from 'react';
import './CarrosselFotos.css';

import foto1 from '../../assets/fotos/img1.png';
import foto2 from '../../assets/fotos/img2.png';
import foto3 from '../../assets/fotos/img3.png';
import foto4 from '../../assets/fotos/img4.png';

export default function CarrosselFotos() {
  const imagens = [foto1, foto2, foto3, foto4];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % imagens.length);
    }, 3000); 

    return () => clearInterval(intervalo);
  }, [imagens.length]);

  return (
    <div className="Carrosel-imagem-container">
      {imagens.map((imgSrc, index) => (
        <img
          key={index}
          src={imgSrc}
          alt={`Foto ${index + 1}`}
          className={`foto ${index === currentIndex ? 'ativa' : ''}`}
        />
      ))}
    </div>
  );
}
